export function localDateToUTC(date: Date | null | string, dayEnd = 24 * 60 * 60 * 1000 - 1) {
  const tzOffset = new Date().getTimezoneOffset();

  const cDate = typeof date === 'string' ? new Date(date) : date

  return cDate ? new Date(cDate.getTime() - tzOffset * 60_000 + dayEnd) : null;
}
